function messageFromPayload(payload: unknown): string | null {
  if (!payload || typeof payload !== "object" || Array.isArray(payload)) return null;
  const error = (payload as { error?: unknown }).error;
  if (typeof error === "string" && error.trim()) return error.trim();
  if (!error || typeof error !== "object" || Array.isArray(error)) return null;
  const message = (error as { message?: unknown }).message;
  return typeof message === "string" && message.trim() ? message.trim() : null;
}

/**
 * Supabase reduces non-2xx Edge Function responses to a generic
 * FunctionsHttpError.message. The function's useful, user-facing explanation
 * remains available on error.context as the original Response.
 */
export async function radarFunctionErrorMessage(
  functionName: string,
  error: unknown
): Promise<string> {
  const context =
    error && typeof error === "object" && "context" in error
      ? (error as { context?: unknown }).context
      : null;
  const readJson =
    context && typeof context === "object" && "json" in context
      ? (context as { json?: unknown }).json
      : null;
  if (typeof readJson === "function") {
    try {
      const serverMessage = messageFromPayload(await readJson.call(context));
      if (serverMessage) return serverMessage;
    } catch {
      // Fall through to the provider's message when the response has no JSON body.
    }
  }
  const providerMessage = error instanceof Error ? error.message : String(error);
  return `${functionName}: ${providerMessage}`;
}
